import uiBlockDetectionTask from './ui-block-detect-task';
export default [uiBlockDetectionTask];